import React, { FC } from "react";

/** A person the section can be shown for. */
export interface SelectablePerson {
  /** Stable key passed back to onTabClick. */
  key: string;
  name: string;
  /** Shown under the name, e.g. "Applicant", "Authorized Signer". */
  role: string;
}

interface ApplicantSelectorProps {
  activeTab: string;
  onTabClick: (tab: string) => void;
  /**
   * Explicit list of people. Sections with more than an applicant and a joint
   * applicant — Identity Verification covers authorized signers, beneficiaries
   * and trustees too — pass this. Omit it to keep the original two-person
   * behaviour below.
   */
  people?: SelectablePerson[];
  applicantName?: string;
  coApplicantName?: string;
}

const tabStyle = (active: boolean): React.CSSProperties => ({
  borderBottom: active ? "2px solid #010101" : "none",
  background: "transparent",
  borderTop: "none",
  borderLeft: "none",
  borderRight: "none",
  outline: "none",
});

const ApplicantSelector: FC<ApplicantSelectorProps> = ({
  activeTab,
  onTabClick,
  people,
  applicantName,
  coApplicantName,
}) => {
  // Keep the original two-person shape working for callers that pass names.
  const tabs: SelectablePerson[] = people ?? [
    { key: "applicant", name: applicantName ?? "", role: "Applicant" },
    ...(coApplicantName
      ? [
          {
            key: "coapplicant",
            name: coApplicantName,
            role: "Joint Applicant",
          },
        ]
      : []),
  ];

  return (
    <div className="mb-1" style={{ borderBottom: "1px solid #e3e3e3" }}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className="mr-3"
          style={tabStyle(activeTab === tab.key)}
          onClick={() => onTabClick(tab.key)}
        >
          <div className="text-center">
            <div className="h5 mb-0" style={{ color: "#010101" }}>
              {tab.name}
            </div>
            <div style={{ color: "#a2b0bc", fontSize: "10pt" }}>{tab.role}</div>
          </div>
        </button>
      ))}
    </div>
  );
};

export default ApplicantSelector;
